// copy function -> used in invite link

export function inviteLink() {
    const inviteLink = document.querySelector<HTMLElement>(".copy-invite-link");

    if (inviteLink) {
        const inviteCopyButton: NodeList | null = document.querySelectorAll(
            ".invite-copy-button",
        ) as NodeList;

        for (let i: number = 0; i < inviteCopyButton.length; i++) {
            inviteCopyButton[i].addEventListener("click", function (e: Event) {
                e.preventDefault();
                copyTextToClipboard(String(inviteLink.dataset.copyvalue));
            });
        }
    }

    function fallbackCopyTextToClipboard() {
        try {
            document.execCommand("copy");
        } catch {
            /*console.error('Fallback: Oops, unable to copy', err);*/
        }
    }

    function copyTextToClipboard(text: string) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard();
            return;
        }
        navigator.clipboard.writeText(text).then(
            function () {
                /*console.log('Async: Copying to clipboard was successful!');*/
            },
            function () {
                /*console.error('Async: Could not copy text: ', err);*/
            },
        );
    }
}
